import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button';
import { useCookieConsentStore } from '@/stores/cookie-consent-store';

/** Bottom banner shown until the visitor accepts, rejects, or customizes cookies. */
export function CookieConsentBanner() {
  const { t } = useTranslation();
  const acceptAll = useCookieConsentStore((s) => s.acceptAll);
  const rejectNonEssential = useCookieConsentStore((s) => s.rejectNonEssential);
  const openPreferencesModal = useCookieConsentStore((s) => s.openPreferencesModal);

  return (
    <div
      role="region"
      aria-label={t('cookieConsent.banner.title')}
      className="fixed inset-x-0 bottom-0 z-40 animate-fade-in border-t border-barita-ink/10 bg-white px-6 py-5 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] md:px-[60px]"
    >
      <div className="mx-auto flex max-w-[1920px] flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="max-w-2xl">
          <p className="text-[16px] font-semibold leading-[20px] text-barita-ink">
            {t('cookieConsent.banner.title')}
          </p>
          <p className="mt-1 text-[14px] leading-[18px] text-barita-ink/70">
            {t('cookieConsent.banner.description')}
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <Button variant="outline" size="sm" onClick={openPreferencesModal}>
            {t('cookieConsent.banner.customize')}
          </Button>
          <Button variant="secondary" size="sm" onClick={rejectNonEssential}>
            {t('cookieConsent.banner.rejectNonEssential')}
          </Button>
          <Button variant="primary" size="sm" className="text-white" onClick={acceptAll}>
            {t('cookieConsent.banner.acceptAll')}
          </Button>
        </div>
      </div>
    </div>
  );
}
